/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2026-05-29 18:11:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-05-30 15:23:42
 */
import cardAuthClient from './cardAuthClient'
import { unwrapResponse } from './cardAuthService'

// 卡详情接口地址。
const CARD_DETAILS_ENDPOINT = '/cards/GetCardDetails'
// 卡退款删卡弹窗接口地址
const CARD_REFUND_INFO_ENDPOINT = '/cards/GetCardRefundInfo'
// 卡增值弹窗接口地址
const CARD_TOPUP_INFO_ENDPOINT = '/cards/GetCardTopupInfo'
// 卡统计接口地址
const CARD_STATISTIC_ENDPOINT = '/cards/GetCardStatistic'
// 卡操作接口地址（充值、退款、删卡）
const OPERATE_CARD_ENDPOINT = '/cards/OperateCard'

// 新服务卡 BIN 前缀列表，命中则走新接口，后续追加。
const NEW_CARD_BINS = ['529366']

// 判断卡号是否属于新服务 BIN。
function isNewCard(cardNumber) {
  return NEW_CARD_BINS.some(bin => String(cardNumber).startsWith(bin))
}

// 从新服务响应中按当前语言提取错误消息，兼容旧接口 message 字段。
function extractMessage(res) {
  if (res.message) {
    return res.message
  }
  const lang = localStorage.getItem('admin_lang') === 'TC' ? 'tc' : 'en'
  return res.data?.[lang] || res.data?.en || ''
}

// 获取卡详情，通过 GET query 参数传递 card_id。
function getCardDetails(cardId) {
  return cardAuthClient.get(CARD_DETAILS_ENDPOINT, {
    params: { card_id: cardId },
    includeCsrf: true
  }).then(unwrapResponse)
}

// 获取卡退款删卡信息，传递card_number、card_id
function getCardRefundInfo(cardNumber, cardId) {
  return cardAuthClient.get(CARD_REFUND_INFO_ENDPOINT, {
    params: {
      card_number: cardNumber,
      card_id: cardId,
    },
    includeCsrf: true
  }).then(unwrapResponse)
}

// 获取卡增值弹窗信息，传递传递card_number、card_id
function getCardTopupInfo(cardNumber, cardId) {
  return cardAuthClient.get(CARD_TOPUP_INFO_ENDPOINT, {
    params: {
      card_number: cardNumber,
      card_id: cardId,
    },
    includeCsrf: true
  }).then(unwrapResponse)
}

// 获取卡统计数据，传递 card_number。
function getCardStatistic(cardNumber) {
  return cardAuthClient.get(CARD_STATISTIC_ENDPOINT, {
    params: { card_number: cardNumber },
    includeCsrf: true
  }).then(unwrapResponse)
}

// 卡操作（充值/退款/删卡），POST 传递 type、card_number、card_id、amount、sub_uid（子账户场景）。
function operateCard({ type, card_number, card_id, amount, sub_uid }) {
  const body = { type, card_number, card_id, amount }
  if (sub_uid !== undefined && sub_uid !== null) {
    body.sub_uid = sub_uid
  }
  return cardAuthClient.post(OPERATE_CARD_ENDPOINT, body, {
    includeCsrf: true
  }).then(unwrapResponse)
}

const cardService = {
  getCardDetails,
  getCardRefundInfo,
  getCardTopupInfo,
  getCardStatistic,
  operateCard
}

export {
  CARD_DETAILS_ENDPOINT,
  CARD_REFUND_INFO_ENDPOINT,
  CARD_TOPUP_INFO_ENDPOINT,
  CARD_STATISTIC_ENDPOINT,
  OPERATE_CARD_ENDPOINT,
  NEW_CARD_BINS,
  getCardDetails,
  getCardRefundInfo,
  getCardTopupInfo,
  getCardStatistic,
  operateCard,
  isNewCard,
  extractMessage
}

export default cardService
